// extracted by mini-css-extract-plugin
module.exports = {"content":"banner_content__33XOh","bg":"banner_bg__258Qc","parallelogramSpan":"banner_parallelogramSpan__22pDc","title":"banner_title__m5je7"};